import MarkdownIt from 'markdown-it';
import anchor from 'markdown-it-anchor';
import Prism from 'prismjs';
import 'prismjs/components/prism-typescript.js';
import 'prismjs/components/prism-javascript.js';
import 'prismjs/components/prism-python.js';
import 'prismjs/components/prism-bash.js';
import 'prismjs/components/prism-json.js';

function slugify(s: string): string {
  const lower = s.toLowerCase().trim();
  if (lower === 'for humans') return 'humans';
  if (lower === 'for agents') return 'agents';
  return lower.replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
}

const md: MarkdownIt = new MarkdownIt({
  html: false,
  linkify: true,
  typographer: false,
  highlight: (str: string, lang: string): string => {
    if (lang !== '' && Prism.languages[lang] !== undefined) {
      const highlighted = Prism.highlight(str, Prism.languages[lang], lang);
      return `<pre class="language-${lang}"><code>${highlighted}</code></pre>`;
    }
    return `<pre><code>${md.utils.escapeHtml(str)}</code></pre>`;
  },
});

md.use(anchor, {
  permalink: anchor.permalink.linkInsideHeader({
    symbol: '#',
    placement: 'after',
    ariaHidden: true,
  }),
  slugify,
});

export function renderMarkdown(source: string): string {
  return md.render(source);
}
